/* Black Friday price display; checkout uses the Shopify automatic discount. */
(() => {
  'use strict';
  class PNBenefitChoice extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.refresh();
      this.removeMarcoSelector();
      if(this.scope()) {
        this._optionObserver=new MutationObserver(()=>this.removeMarcoSelector());
        this._optionObserver.observe(this.scope(),{childList:true,subtree:true});
      }
    }
    discountRate() { return Number(this.dataset.discountRate) === 10 ? 10 : 15; }
    removeMarcoSelector() {
      if(!/marco\s*(?:&|and|-)\s*co/i.test(this.dataset.collections || ''))return;
      const scope=this.scope();
      if(!scope)return;
      for(const label of scope.querySelectorAll('label,.gpo-label')) {
        if(label.textContent.trim().replace(/\s*\*$/, '').toLowerCase() !== 'seleccionar')continue;
        let group=label.closest('fieldset,.gpo-element,.gpo-field,.globo-form-control');
        if(!group) {
          let parent=label.parentElement;
          while(parent && parent!==scope) {
            if(parent.querySelector('select')) {group=parent;break;}
            parent=parent.parentElement;
          }
        }
        if(!group || !group.querySelector('select') || group.querySelector('button,[data-pn-choice]'))continue;
        group.hidden=true;
        group.style.setProperty('display','none','important');
        // Preserve native variant inputs so variant resolution still works.
        group.querySelectorAll('[name^="properties["]').forEach(field=>{field.disabled=true;field.required=false;});
      }
    }
    disconnectedCallback() { this._optionObserver?.disconnect(); }
    scope() { return this.closest('.shopify-section') || this.closest('section'); }
    form() { return this.scope()?.querySelector('form[data-type="add-to-cart-form"]'); }
    refresh() {
      const price = Number(this.dataset.price);
      if (!Number.isFinite(price) || price < 0) return;
      const currency = this.dataset.currency || 'CLP';
      const formatter = new Intl.NumberFormat(currency === 'CLP' ? 'es-CL' : (this.dataset.locale || 'es'), {style:'currency',currency});
      const format = cents => formatter.format(cents / 100);
      const discount = Math.round(price * (100 - this.discountRate()) / 100);
      this.querySelector('[data-pn-original]').textContent = format(price);
      this.querySelector('[data-pn-current]').textContent = format(discount);
    }
  }
  if(!customElements.get('pn-benefit-choice'))customElements.define('pn-benefit-choice',PNBenefitChoice);
  document.addEventListener('pn:variant-price',event=>{
    const {container,variant}=event.detail || {};
    const benefit=container?.querySelector('pn-benefit-choice');
    if(benefit && variant){benefit.dataset.price=String(variant.price);benefit.dataset.variant=String(variant.id);benefit.refresh();}
  });
})();
